import { useEffect } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import About from './components/About';
// CORRECCIÓN AQUÍ: Asegúrate de que el archivo se llame RegistroTaller.js (con R y T mayúsculas)
import Contact from './components/RegistroTaller';
import Footer from './components/Footer';

const LandingPage = () => {
  useEffect(() => {
    if (window.lucide) {
      window.lucide.createIcons();
    }
  }, []);

  return (
    <>
      <Header />
      <main>
        <Hero />
        <Services />
        <About />
        {/* Aquí estás usando el componente RegistroTaller bajo el nombre 'Contact' */}
        <Contact /> 
      </main>
      <Footer />
    </>
  );
};

export default LandingPage;